var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4696 4.15488C11.3824 3.88688 11.1231 3.70275 10.7579 3.64968L7.78157 3.2172L6.45041 0.520643C6.28713 0.189835 6.03181 0 5.75 0C5.46818 0 5.21287 0.189835 5.04959 0.520731L3.7186 3.2172L0.742176 3.64968C0.376923 3.70275 0.117481 3.88688 0.0304453 4.15488C-0.0565909 4.42288 0.0450098 4.7243 0.309277 4.98177L2.46307 7.08075L1.95454 10.0447C1.88953 10.4237 2.00034 10.6509 2.10475 10.7747C2.22723 10.92 2.40586 11 2.60775 11C2.75962 11 2.92115 10.9555 3.08794 10.8679L5.75 9.4686L8.41223 10.868C8.57894 10.9556 8.74046 11 8.89234 11H8.89242C9.09422 11 9.27294 10.92 9.39543 10.7747C9.49975 10.6509 9.61065 10.4237 9.54555 10.0447L9.0371 7.08075L11.1908 4.98177C11.455 4.7243 11.5566 4.42288 11.4696 4.15488Z",
    fill: "#B37803"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullStar);
export default __webpack_public_path__ + "static/media/full-star.3c9eb402048904918cbeea05b5d7552b.svg";
export { ForwardRef as ReactComponent };